import { apiClient } from '@/lib/api/client'

export interface GraphSubscriptionRow {
  id: number
  subscription_id: string
  resource: string | null
  mailbox_email: string | null
  change_type: string | null
  notification_url: string | null
  expiration_date_time: string | null
  is_active: boolean
}

export interface GraphSubscriptionStatusResponse {
  success: boolean
  data: GraphSubscriptionRow[]
  message?: string
}

export interface GraphSubscriptionMutationResponse {
  success: boolean
  message?: string
  data?: {
    subscription_id?: string
    expiration_date_time?: string
  }
}

export async function getGraphMailboxSubscriptionStatus(): Promise<GraphSubscriptionStatusResponse> {
  const { data } = await apiClient.get<GraphSubscriptionStatusResponse>(
    '/system-settings/mailbox-graph-subscription/status',
  )
  return data
}

export async function createGraphMailboxSubscription(body: {
  mailbox_email: string
  change_type?: string
  notification_url?: string
}): Promise<GraphSubscriptionMutationResponse> {
  const { data } = await apiClient.post<GraphSubscriptionMutationResponse>(
    '/system-settings/mailbox-graph-subscription/create',
    body,
  )
  return data
}

export async function renewGraphMailboxSubscription(body?: {
  id?: number
}): Promise<GraphSubscriptionMutationResponse> {
  const { data } = await apiClient.post<GraphSubscriptionMutationResponse>(
    '/system-settings/mailbox-graph-subscription/renew',
    body ?? {},
  )
  return data
}

export async function deleteGraphMailboxSubscription(body: { id: number }): Promise<GraphSubscriptionMutationResponse> {
  const { data } = await apiClient.post<GraphSubscriptionMutationResponse>(
    '/system-settings/mailbox-graph-subscription/delete',
    body,
  )
  return data
}
